module.exports = __webpack_public_path__ + "static/media/svg-2.d4846e11.svg";